import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui';
import { useAuth } from '@/lib/auth/useAuth';

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface-muted p-6">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-rose-100 text-rose-600 dark:bg-rose-500/15 dark:text-rose-400">
        <ShieldOff className="h-8 w-8" />
      </div>

      <div className="text-center">
        <h1 className="mb-2 text-2xl font-semibold">You don't have access to this area.</h1>
        <p className="max-w-sm text-sm text-fg-muted">
          Contact your Authmatech administrator if you believe this is a mistake.
        </p>
        {user && (
          <p className="mt-3 text-xs text-fg-subtle">
            Signed in as <span className="font-medium">{user.email}</span>
            {user.roles.length > 0 && (
              <> · role: {user.roles[0]?.replace('AUTHMATECH_', '')}</>
            )}
          </p>
        )}
      </div>

      <div className="flex gap-3">
        <Button variant="outline" onClick={() => navigate('/overview')}>
          Go to overview
        </Button>
        <Button variant="ghost" onClick={logout}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
